/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Line_BreaksInputs */



/**
* | output |
* | --- |
* | "Automatically Insert Line Breaks" |
*
* @param {Options_Editor_Auto_Line_BreaksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_line_breaks = /** @type {((inputs?: Options_Editor_Auto_Line_BreaksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Line_BreaksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer automatiquement des retours à la ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Zeilenumbrüche einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci automaticamente interruzioni di riga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая вставка переносов строк")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar saltos de línea automáticamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动插入换行符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("改行を自動的に挿入する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित रूप से लाइन ब्रेक डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir quebras de linha automaticamente")
	return /** @type {LocalizedString} */ ("Automatically Insert Line Breaks")
});